import React, { Component } from 'react';
import { TextField, TextArea, RadioField, CheckboxField, SelectField, ToolTip, RequiredFlag, Accordion, Collapsible, EmailPreview } from './eventFormComponents';
import { GuestListContainer } from '../../containers';
import * as styled from '../../styles/style';
import { validator, errorMessages } from '../../helpers/validation';
import kit from '../../images/OTT_Kit.jpg';
import { hostType, sharePreferences, invitationDate, invitationDateSelect, invitationDateLabels, invitationTime } from '../../helpers/enums';
import authHeader from '../../helpers/authHeader';
export const moment = require('moment');

class EventForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: this.props.event,
      user: this.props.user,
      guests: this.props.guests,
      warnings: {},
      sections: {
        step1: true,
        step2: true,
        step3: true,
        step4: true,
        step5: true,
        step6: true,
        step7: true,
      },
    }
    this.uploadButton = React.createRef()
    this.handleCancel = this.handleCancel.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    let newState = {}
    if (nextProps.user !== this.state.user) {
      newState.warnings = {}
    }

    // TODO: FIXME: this is the reason changes from the EventForm are reflected up in the heirarchy in EventDetails
    //              the state is kept as a reference to the props and in a way EventForm is modifying its own props.

    newState.event = nextProps.event;
    newState.user = nextProps.user;
    newState.guests = nextProps.guests;

    let event = newState.event;
    let step1, step2, step3, step4, step5, step6, step7;

    if (event) {
      step1 = (
        event.postal_code !== null && event.postal_code !== ''
      );
      step2 = (
        event.venue !== null && event.venue !== ''
      );
      step3 = (
        event.food1 !== null && event.food1 !== '' &&
        event.food2 !== null && event.food2 !== '' &&
        event.topic !== null && event.topic !== ''
      );
      step4 = (
        event.address_1 !== null && event.address_1 !== '' &&
        event.city !== null && event.city !== '' &&
        event.province !== null && event.province !== '' &&
        event.postal_code !== null && event.postal_code !== ''
      );
      step5 = (
        event.invitation_date !== null && event.invitation_date !== '' &&
        event.invitation_start_time !== null && event.invitation_start_time !== '' &&
        event.invitation_message !== null && event.invitation_message !== ''
      );
      step6 = !(
        event.invitation_date !== null && event.invitation_date !== '' &&
        event.invitation_start_time !== null && event.invitation_start_time !== '' &&
        event.invitation_message !== null && event.invitation_message !== ''
      );
      step7 = true;

      let sections;

      if (Object.keys(this.state.sections).length > 1) {
        sections = this.state.sections;
      }
      else {
        sections = {
         step1: step1,
         step2: step2,
         step3: step3,
         step4: step4,
         step5: step5,
         step6: step6,
         step7: step7,
        }
      }

      // stepX is CLOSED state
      this.setState({
        event: newState.event,
        user: newState.user,
        sections: sections,
      })
    }

    this.setState(newState);
  }

  shuboxify = () => {
    let elem = this.uploadButton.current;
    if (elem) {
      if (elem.dropzone) {
        elem.dropzone.destroy();
      }
      new window.Shubox(`#${this.uploadButton.current.id}`, {
        previewsContainer: false,
        acceptedFiles: "image/gif,image/png,image/jpeg",
        success: (file) => {
          let event = this.state.event;
          event.invitation_logo = file.s3url;
          this.setState({
            event: event
          })
        },
      })

      elem.dropzone.on("totaluploadprogress", function(progress) {
        document.querySelector(".upload-progress").style.width = Math.round(progress) + "%";
        document.querySelector(".percent-complete").innerHTML = Math.round(progress) + "%";
      });

      elem.dropzone.on("sending", function(file) {
        document.querySelector(".upload").style.display = "block";
        document.querySelector(".percent-complete").style.display = "block";
        document.querySelector(".upload").style.opacity = "1";
        document.querySelector(".upload-progress").style.opacity = "1";
        document.querySelector(".percent-complete").style.opacity = "1";
        if (document.querySelector(".invitation-logo")) {
          document.querySelector(".invitation-logo").style.opacity = "0";
        }
      });

      elem.dropzone.on("queuecomplete", function(progress) {
        setTimeout(function() {
          document.querySelector(".upload").style.display = "none";
          document.querySelector(".percent-complete").style.display = "none";
          document.querySelector(".upload").style.opacity = "0";
          document.querySelector(".upload-progress").style.opacity = "0";
          document.querySelector(".percent-complete").style.opacity = "0";
          if (document.querySelector(".invitation-logo")) {
            document.querySelector(".invitation-logo").style.opacity = "1";
          }
        }, 1000)
      });
    }
  }

  componentDidMount() {
    this.shuboxify();
  }

  componentDidUpdate() {
    this.shuboxify();
  }

  handleUserChange = (e) => {
    let name, warning_name;
    name = warning_name = e.target.name;
    let user = this.state.user;
    user[name] = e.target.value;
    
    console.log("handleUserChange called", name);

    if (this.validateUserChange(name, e.target.value)) {
      this.setState({
        user: user
      });
      this.setWarningMessage(name, '');
    }
    else {
      if (name === 'email' && e.target.value == '') { warning_name = 'email_required' }
      this.setWarningMessage(name, errorMessages[warning_name]);
    }
  }

  validateUserChange = (name, value) => {
    switch(name) {
      case 'email':
        return validator.isEmail(value);
        break;
      case 'password':
        if (value === '' || (value !== '' && value === this.state.user.repeat_password )) {
          this.setWarningMessage('repeat_password', '');
          return true;
        }
        else {
          this.setWarningMessage('repeat_password', errorMessages['repeat_password']);
          return false;
        }
      case 'repeat_password':
        if ((this.state.user.password !== '' && value === this.state.user.password) || value === '') {
          return true;
        }
        else {
          return false;
        }
      default:
        return value !== '';
    }
  }

  handleEventChange = (e, max) => {
    console.log('handle Event Change');

    let name, warning_name;

    if ( !!e.target.name.match(/capacity/) ) { name = e.target.name.slice(0,8) }
    else if ( !!e.target.name.match(/share_preferences/) ) { name = e.target.name.slice(0,17) }
    else if ( !!e.target.name.match(/invitation_start_ampm/) ) { name = e.target.name.slice(0,21) }
    else if ( !!e.target.name.match(/invitation_end_ampm/) ) { name = e.target.name.slice(0,19) }
    else { name = warning_name = e.target.name }

    let event = this.state.event;
    event[name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    if (!!name.match(/food/) || name === 'topic') {
      if (e.target.value.length > max) {
        this.setWarningMessage(name, `${max} characters or less, please.`);
        return;
      } else if (e.target.value.trim() === '') {
        this.setWarningMessage(name, errorMessages[`${name}_required`]);
        return;
      }
    }

    if (['address_1', 'city', 'postal_code', 'province'].indexOf(name) >= 0) {
      if (e.target.value === '') {
        this.setWarningMessage(name, errorMessages[`${name}_required`]);
        return;
      }
    }

    if (name === 'extra_directions') {
      if (e.target.value.length > max) {
        this.setWarningMessage(name, `${max} characters or less, please.`);
        return;
      }
    }

    if (name === 'share_preferences') {
      if (event.share_preferences == 3) {
        if (event.twitter === '' && event.instagram === '') {
          this.setWarningMessage('social_handle', errorMessages['social_handle_required']);
          return;
        }
      }
    }

    if (name === 'instagram' || name === 'twitter') {
      if (event.share_preferences == 3) {
        if (e.target.value === '') {
          let twitter = event.twitter ? event.twitter.trim() : '';
          let instagram = event.instagram ? event.instagram.trim() : '';
          let otherHandleEmpty = (name === 'instagram' ? twitter === '' : instagram === '' );
          // Todo if the other one is also empty:
          if (otherHandleEmpty) {
            this.setWarningMessage('social_handle', errorMessages['social_handle_required']);
            return;
          }
        }
      }
    }

    if (name.includes('invitation')) {
      if (e.target.value === '') {
        this.setWarningMessage(name, errorMessages[`${name}_required`]);
        return;
      }
    }

    if (name === 'invitation_start_time' || name === 'invitation_end_time') {
      console.log('HERE:', name);
      let time = e.target.value;
      if (!moment(time, "h:m", true).isValid() && !moment(time, "h", true).isValid()) {
        this.setWarningMessage(name, errorMessages[`${name}_invalid`]);
        return;
      }
    }

    if (this.validateEventChange(name, e.target.value)) {
      this.setState({
        event: event
      })
      this.setWarningMessage(name, '');
      if (name === 'instagram' || name === 'twitter') {
        this.setWarningMessage('social_handle', '');
      }
    } else {
      if (name === 'postal_code' && e.target.value === '') { warning_name = 'postal_code_required' }
      this.setWarningMessage(name, errorMessages[warning_name]);
    }
  }

  validateEventChange = (name, value) => {
    console.log('name: ', name, value);
    switch(name) {
      case 'postal_code':
        return validator.isPostalCode(value, 'CA');
      case 'swag_postal':
        return validator.isPostalCode(value, 'CA');
      default:
        return true
    }
  }

  setWarningMessage = (name, message) => {
    let warning = this.state.warnings;
    warning[name] = message;

    this.setState({
      warnings: warning
    })
  }

  setWarningMessages = (warnings) => {
    this.setState({
      warnings: warnings
    })
  }

  onFocus = () => {
    if (this.props.alert && this.props.clearAlert) {
      this.props.clearAlert();
    }
  }

  setSectionState = (e, step) => {
    console.log("set section state called!")
    let sections = this.state.sections;
    sections[step] = !sections[step];

    this.setState({
      sections: sections
    })
  }

  setSectionStateAndScroll = (e, step) => {
    let sections = this.state.sections;
    if (sections[step]) { sections[step] = false; }

    this.setState({
      sections: sections
    }, () => {
      let target = document.getElementById(step);
      window.scrollTo(0, target.offsetTop);
    })
  }

  handleRemoveImage = () => {
    let event = this.state.event;
    event.invitation_logo = null;
    this.setState({
      event: event,
    });
  }

  handleSignInAs = () => {
    const requestOptions = {
      headers: authHeader(),
      method: 'POST',
    };

    let user_id = this.state.user.id;
    let url = '/api/admin/users/' + user_id + '/sign_in_as';

    return fetch(url, requestOptions)
      .then(res => res.json())
      .then(
        res => {
          let url = "/host/signin/" + res.token;
          window.open(url, '_self');
        },
        error => {
          console.log(error);
        })
      .catch((error) => {
        console.log(error);
      })
  }

  handleCancel() {
    let event = this.state.event
    event.cancelled = !event.cancelled
    this.setState({
      event: event,
    })
  }

  render() {
    const { user, event, guests, showAdminTools } = this.state;
    const { admin } = this.props;

    let invitationDateBlock = null;

    if (event) {
      invitationDateBlock = (
        <SelectField
          name='invitation_date'
          value={event.invitation_date}
          values={invitationDateSelect}
          labels={invitationDateSelect.map(index => invitationDateLabels[index])}
          update={this.handleEventChange}
          required={true}
          label={'What day is your gathering?'}
          errorMessage={this.state.warnings}
        />
      )
    }

    return (
      <div>
        {event && user && admin && (
          <Accordion title="Admin Tools" admin closed={this.state.sections.admin} id="admin" update={this.setSectionState}>
            <styled.TightFormRow style={{justifyContent: 'flex-start'}}>
              <styled.PlainLinkButton href={`mailto:${user.email}`}>Email Host</styled.PlainLinkButton>
              <styled.PlainLinkButton onClick={this.handleSignInAs}>Sign In As</styled.PlainLinkButton>
            </styled.TightFormRow>
            <styled.TightFormRow>
              <styled.FullWidthFieldGroup>
                <styled.CheckboxGroup>
                  <CheckboxField label='Needs Follow Up' name="follow_up" value={event.follow_up || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                  <CheckboxField label='Premium Host' name="premium" value={event.premium || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                  <CheckboxField label='Public Event' name="public" value={event.public || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                  <CheckboxField label='Cancelled' name="cancelled" value={event.cancelled || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                </styled.CheckboxGroup>
              </styled.FullWidthFieldGroup>
            </styled.TightFormRow>
            <styled.FormRow>
              <styled.FullWidthFieldGroup>
                <TextArea value={event.notes} name='notes' label='Notes' update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
              </styled.FullWidthFieldGroup>
            </styled.FormRow>
          </Accordion>
        )}

        {event && user && (
          <Accordion title="Step 1: Your Account" closed={this.state.sections.step1} update={this.setSectionState} id="step1">
            <p style={{marginTop: 0, paddingLeft: '20px'}}><span style={{color: 'red'}}>*</span> = Required</p>
            <styled.FormRow>
              <styled.HalfWidthFieldGroup>
                <TextField value={user.firstname} name='firstname' label='First Name' update={this.handleUserChange} onFocus={this.onFocus} errorMessage={this.state.warnings} required={true} />
              </styled.HalfWidthFieldGroup>
              <styled.HalfWidthFieldGroup>
                <TextField value={user.lastname} name='lastname' label='Last Name' update={this.handleUserChange} onFocus={this.onFocus} errorMessage={this.state.warnings} required={true} />
              </styled.HalfWidthFieldGroup>
            </styled.FormRow>

            <styled.FormRow>
              <styled.HalfWidthFieldGroup>
                <TextField value={user.email} name='email' label='Email' update={this.handleUserChange} onFocus={this.onFocus} errorMessage={this.state.warnings} required={true} />
              </styled.HalfWidthFieldGroup>
              <styled.HalfWidthFieldGroup style={{position: 'relative'}}>
                  <TextField value={event.organization_name} name='organization_name' label='Organization Name' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
              </styled.HalfWidthFieldGroup>
            </styled.FormRow>

            <styled.FormRow>
              <styled.HalfWidthFieldGroup>
                <RequiredFlag text="Set a password" show={user.password_digest === 'no-digest-will-match-this' && typeof user.password === 'undefined'}>
                  <TextField value={user.password} required={user.password_digest === 'no-digest-will-match-this'} type='password' name='password' label='Password' update={this.handleUserChange} errorMessage={this.state.warnings} onFocus={this.onFocus} autoComplete="false" />
                </RequiredFlag>
              </styled.HalfWidthFieldGroup>
              <styled.HalfWidthFieldGroup>
                <TextField value={user.repeat_password} required={user.password_digest === 'no-digest-will-match-this'} type='password' name='repeat_password' label='Repeat Password' update={this.handleUserChange} errorMessage={this.state.warnings} onFocus={this.onFocus} autoComplete="false" />
              </styled.HalfWidthFieldGroup>
            </styled.FormRow>

            <styled.FormRow>
              <styled.HalfWidthFieldGroup>
                  <TextField value={event.phone_number} name='phone_number' label='Phone Number' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
              </styled.HalfWidthFieldGroup>
              <styled.HalfWidthFieldGroup>
                  <TextField value={event.postal_code} name='postal_code' label='Postal Code' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required={true} />
                <ToolTip linkText='Why do you want this?'>On the Table BC uses your postal code to plan support across the province.</ToolTip>
              </styled.HalfWidthFieldGroup>
            </styled.FormRow>

            <styled.FormRow>
              <styled.FullWidthFieldGroup>
                <styled.Label htmlFor="capacity-group">Approximately how many guests do you intend to invite?</styled.Label>
                  <RadioField name='capacity' update={this.handleEventChange} formProp={this.state.event.capacity} values={hostType} labels={['12 or fewer', '13 - 24', 'More than 24']} display={'flex'} />
              </styled.FullWidthFieldGroup>
            </styled.FormRow>

            {event && (
              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <styled.Label htmlFor="capacity-group">How did you hear about On the Table BC?</styled.Label>
                  <SelectField name='referral' value={this.state.event.referral} values={['Vancouver Foundation', 'Social Media', 'Advertising', 'Word of Mouth', 'Postcard', 'Other (please specify)']} update={this.handleEventChange} />
                  {event.referral === 'Other (please specify)' && (
                    <div style={{marginTop: '15px'}}>
                      <TextField name='referral_other' value={this.state.event.referral_other} label='Write in your answer here:' update={this.handleEventChange} />
                    </div>
                  )}
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>
            )}
          </Accordion>
        )}

        {event && user && (
          <Accordion title="Step 2: Save the Date" closed={this.state.sections.step2} update={this.setSectionState} id="step2">
            <styled.InternalRow>
              <TextField value={event.save_the_date_from} name='save_the_date_from' label='From' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required />
            </styled.InternalRow>
            <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextArea value={event.save_the_date_message} name='save_the_date_message' label='Message' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>
          </Accordion>
        )}

        {event && (
          <Accordion title="Step 3: Host Perks" closed={this.state.sections.step3} update={this.setSectionState} id="step3">
            {admin && (
              <div>
                <styled.TightFormRow>
                  <styled.FullWidthFieldGroup>
                    {/*
                    <p style={{marginTop: 0, paddingLeft: '15px', lineHeight: 1.4 }}>If your gathering is in BC, we can send you a free swag bag. Swag bags can be requested until July 13, or while supplies last.</p>
                    */}
                    <CheckboxField label='Yes, I would like to request swag bags' name="swag" value={event.swag || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                  </styled.FullWidthFieldGroup>
                </styled.TightFormRow>

                {event.swag && (
                  <div>
                    <styled.FormRowReverse>
                      <styled.HalfWidthFieldGroup style={{lineHeight: 1.4}}>
                      {/*
                        <img style={{width: '100%'}} src={kit}/>
                        <p>The swag bag is a zippered tote full of accessories for your event including:</p>
                        <ul>
                          <li>1 host guide</li>
                          <li>1 photo banner</li>
                          <li>12 each of coasters, notebooks and pens for your guests.</li>
                        </ul>
                      */}
                      </styled.HalfWidthFieldGroup>
                      <styled.HalfWidthFieldGroup>
                        <styled.InternalRow>
                          <p style={{paddingLeft: '15px'}}><strong>Ship my swag bags to:</strong></p>
                          <TextField value={event.swag_address_1} name='swag_address_1' label='Address' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required />
                          <div style={{marginTop: '15px'}}>
                            <TextField value={event.swag_address_2} name='swag_address_2' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                          </div>
                        </styled.InternalRow>

                        <styled.InternalRow>
                          <TextField value={event.swag_city} name='swag_city' label='City' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required />
                        </styled.InternalRow>

                        <styled.InternalRow>
                          <TextField value="British Columbia" name='swag_province' label='Province' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} disabled required />
                        </styled.InternalRow>

                        <styled.InternalRow>
                          <TextField value={event.swag_postal} name='swag_postal' label='Postal Code' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required short />
                        </styled.InternalRow>
                        {/*
                        <TextField value={event.swag_guests} name='swag_guests' label='Approximately how many guests do you expect?' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required short />
                        <ToolTip left linkText='Why is this important?'>Each swag bag has enough items for 12 people, please confirm your intended guest list number with that in mind.</ToolTip>
                        */}
                      </styled.HalfWidthFieldGroup>
                    </styled.FormRowReverse>
                  </div>
                )}
                <styled.TightFormRow>
                  <styled.FullWidthFieldGroup>
                    {/*
                    <p style={{marginTop: 0, paddingLeft: '15px', lineHeight: 1.4 }}>If your gathering is in BC, we can send you a free swag bag. Swag bags can be requested until July 13, or while supplies last.</p>
                    */}
                    <CheckboxField label='Yes, I would like a grant' name="grant_agree" value={event.grant_agree || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                  </styled.FullWidthFieldGroup>
                </styled.TightFormRow>
                {event.grant_agree && (
                  <div>
                    <styled.FormRowReverse>
                      <styled.HalfWidthFieldGroup style={{lineHeight: 1.4}}>
                      {/*
                        <img style={{width: '100%'}} src={kit}/>
                        <p>The swag bag is a zippered tote full of accessories for your event including:</p>
                        <ul>
                          <li>1 host guide</li>
                          <li>1 photo banner</li>
                          <li>12 each of coasters, notebooks and pens for your guests.</li>
                        </ul>
                      */}
                      </styled.HalfWidthFieldGroup>
                      <styled.HalfWidthFieldGroup>
                        <styled.InternalRow>
                          <TextField value={event.grant_amount} name='grant_amount' label='Grant Amount' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required short />
                        </styled.InternalRow>

                        <styled.InternalRow>
                          <TextField value={event.grant_purpose} name='grant_purpose' label='Grant Purpose' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required />
                        </styled.InternalRow>
                        {/*
                        <TextField value={event.swag_guests} name='swag_guests' label='Approximately how many guests do you expect?' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required short />
                        <ToolTip left linkText='Why is this important?'>Each swag bag has enough items for 12 people, please confirm your intended guest list number with that in mind.</ToolTip>
                        */}
                      </styled.HalfWidthFieldGroup>
                    </styled.FormRowReverse>
                  </div>
                )}
              </div>
            )}

            {!admin && (
              <div>
                {event.swag && (
                  <p style={{marginLeft: '20px'}}><strong>Thanks for registering for an On the Table BC swag bag. You can expect to receive it in your mailbox early September!</strong></p>
                )}
                {!event.swag && (
                  <p style={{marginLeft: '20px'}}><strong>Registration for swag bags has now closed. But don’t worry, we will have digital assets available in the coming weeks to help you plan and host your gathering. We will let you know when those are available in our next newsletter.</strong></p>
                )}
              </div>
            )}
            {/*
            <styled.FormRow>
              <styled.FullWidthFieldGroup>
                <p style={{marginLeft: '15px'}}><strong>It’s time to start planning where you’ll host your event.</strong></p>
                <styled.Label htmlFor="venue-group">What kind of venue are you considering?</styled.Label>
                <SelectField name='venue' value={this.state.event.venue} values={['Café', 'Restaurant', 'Office', 'Home', 'Backyard', 'Park', 'Not Sure Yet', 'Other (please specify)']} update={this.handleEventChange} />
                {event.venue === 'Other (please specify)' && (
                  <div style={{marginTop: '15px'}}>
                    <TextField name='venue_other' value={this.state.event.venue_other} label='Write in your answer here:' update={this.handleEventChange} />
                  </div>
                )}
              </styled.FullWidthFieldGroup>
            </styled.FormRow>
            */}
          </Accordion>
        )}

        {event && user && (
          <Accordion title="Step 4: Design Invitation" id="step4" closed={this.state.sections.step4} update={this.setSectionState}>
            <div>
              {/*
              <p style={{marginLeft: '20px'}}>It&#39;s time to think about the foods you&#39;ll be serving and the topic of conversation.</p>
              <Collapsible linkText={"Need some suggestions or guidance?"}>
                <p className="combination-text" style={{width: '50%', marginTop: 0, marginLeft: '5px', lineHeight: '1.25'}}>
                  This is your chance to get creative with your event and make it uniquely yours! If you’re having a hard time trying to decide what to serve we recommend letting your topic inspire the food and drinks you provide. Perhaps there a particular mixture of food and/or beverages that represents your community or even adds a little spice or cheekiness to your topic. We’re excited to see what combinations you come up with.
                </p>
                <styled.ImageCarousel />
              </Collapsible>
              <styled.Label style={{marginTop: '20px', marginLeft: '20px', marginBottom: '15px'}}>What will you be serving?</styled.Label>
              */}
              <styled.TightFormRow>
                <styled.FullWidthFieldGroup>
                  <h2 style={{marginLeft: '15px', marginTop: '15px' }}>Graphic:</h2>
                </styled.FullWidthFieldGroup>
              </styled.TightFormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextField value={event.food1} required={true} name='food1' label='Food' update={(e) => this.handleEventChange(e, 15)} errorMessage={this.state.warnings} onFocus={this.onFocus} count={true} max={15} />
                </styled.HalfWidthFieldGroup>
                <styled.HalfWidthFieldGroup>
                  <TextField value={event.food2} required={true} name='food2' label='Food or Drink' update={(e) => this.handleEventChange(e, 15)} errorMessage={this.state.warnings} onFocus={this.onFocus} count={true} max={15} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>
              <styled.FormRow>
                <styled.FullWidthFieldGroup>
                  <TextField value={event.topic} required={true} name='topic' label='Your Topic' update={(e) => this.handleEventChange(e, 26)} errorMessage={this.state.warnings} onFocus={this.onFocus} count={true} max={26} />
                </styled.FullWidthFieldGroup>
              </styled.FormRow>

              <styled.TightFormRow>
                <styled.FullWidthFieldGroup>
                  <h2 style={{marginLeft: '15px', marginTop: '15px' }}>Message:</h2>
                </styled.FullWidthFieldGroup>
              </styled.TightFormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextField value={event.host_name} name='host_name' label='Hosting Person or Organization' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextArea value={event.invitation_message} name='invitation_message' label='Your Message' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              <styled.TightFormRow>
                  <styled.FullWidthFieldGroup>
                    <h2 style={{marginLeft: '15px', marginTop: '15px' }}>Time:</h2>
                  </styled.FullWidthFieldGroup>
                </styled.TightFormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextField value={event.invitation_date} name='invitation_date' label='Event Date' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextField value={event.invitation_start_time} name='invitation_start_time' label='Start and End Time' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              <styled.TightFormRow>
                <styled.FullWidthFieldGroup>
                  <h2 style={{marginLeft: '15px', marginTop: '15px' }}>Place:</h2>
                </styled.FullWidthFieldGroup>
              </styled.TightFormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <styled.Label htmlFor="event_type-group" style={{marginBottom: '15px'}}>Event Type:</styled.Label>
                  <RadioField name='event_type' style={{display: 'block'}} update={this.handleEventChange} formProp={this.state.event.event_type} values={['online', 'in_person', 'online_in_person']} labels={["Online Only", "In-Person Only", "Online + In-Person"]} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              {['online', 'online_in_person'].indexOf(event.event_type) > -1 && <React.Fragment>
                <styled.TightFormRow>
                  <styled.FullWidthFieldGroup>
                    <h2 style={{marginLeft: '15px', marginTop: '15px' }}>Online Guests:</h2>
                  </styled.FullWidthFieldGroup>
                </styled.TightFormRow>

                <styled.FormRow>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.online_url} name='online_url' label='Online meeting URL' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                  </styled.HalfWidthFieldGroup>
                </styled.FormRow>
              </React.Fragment>}

              {['in_person', 'online_in_person'].indexOf(event.event_type) > -1 && <React.Fragment>
                <styled.TightFormRow>
                  <styled.FullWidthFieldGroup>
                    <h2 style={{marginLeft: '15px', marginTop: '15px' }}>In-Person Guests:</h2>
                  </styled.FullWidthFieldGroup>
                </styled.TightFormRow>

                <styled.FormRow>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.address_description} name='address_description' label='Location Name' update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} autoComplete='address-line2' />
                  </styled.HalfWidthFieldGroup>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.address_1} name='address_1' label='Address 1' update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} required={true} autoComplete='address-line1' />
                  </styled.HalfWidthFieldGroup>
                </styled.FormRow>
                <styled.FormRow>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.city} name='city' label='City' update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} required={true} autoComplete='address-level2' />
                  </styled.HalfWidthFieldGroup>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.province} name='province' label='Province' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required={true} autoComplete='address-level1' />
                  </styled.HalfWidthFieldGroup>
                </styled.FormRow>
                <styled.FormRow>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.postal_code} name='postal_code' label='Postal Code' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required autoComplete='postal-code' />
                  </styled.HalfWidthFieldGroup>
                </styled.FormRow>

                <styled.FormRow>
                  <styled.FullWidthFieldGroup>
                    <TextArea value={event.extra_directions} name='extra_directions' label='Extra directions and access notes' update={(e) => this.handleEventChange(e, 100)} onFocus={this.onFocus} errorMessage={this.state.warnings} count={true} max={100}>
                      <ToolTip style={{marginBottom: '7px'}} linkText='What should I write here?'>Use this area for tips to help guests find and access your venue, such as parking spots or a buzzer code.</ToolTip>
                    </TextArea>
                  </styled.FullWidthFieldGroup>
                  <styled.HalfWidthFieldGroup></styled.HalfWidthFieldGroup>
                </styled.FormRow>

              </React.Fragment>}

              <styled.TightFormRow>
                  <styled.FullWidthFieldGroup>
                    <h2 style={{marginLeft: '15px', marginTop: '15px' }}>RSVP Options:</h2>
                  </styled.FullWidthFieldGroup>
                </styled.TightFormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <CheckboxField label='Use another service' name="external_rsvp" value={event.external_rsvp || false} update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  <TextField value={event.registration_url} name='registration_url' label='Guest Registration URL' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} />
                </styled.HalfWidthFieldGroup>
              </styled.FormRow>

              <styled.FormRow>
                <styled.FullWidthFieldGroup>
                  <styled.Label htmlFor="share_preferences-group" style={{marginBottom: '15px'}}>Sharing preferences:</styled.Label>
                  <RadioField name='share_preferences' style={{display: 'block'}} update={this.handleEventChange} formProp={this.state.event.share_preferences} values={sharePreferences} labels={["No, don't share my combination.", "Yes, but keep me anonymous.", "Yes, and attribute it to me/my organization."]} />
                </styled.FullWidthFieldGroup>
              </styled.FormRow>
              {event.share_preferences == 3 && (
                <styled.FormRow>
                  {/*
                  <styled.Label htmlFor="social-group" style={{marginBottom: '20px'}}>Thank you! Please leave your Twitter and/or Instagram handle below so we can credit you.</styled.Label>
                  */}
                  <styled.FullWidthFieldGroup>
                    {this.state.warnings['social_handle'] && (<styled.ErrorMessage style={{display: 'block', margin: '10px 0px 10px 6px'}}>{this.state.warnings['social_handle']}</styled.ErrorMessage>)}
                  </styled.FullWidthFieldGroup>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.twitter} name='twitter' label='Your Twitter Handle' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} prepend={"@"} />
                  </styled.HalfWidthFieldGroup>
                  <styled.HalfWidthFieldGroup>
                    <TextField value={event.instagram} name='instagram' label='Your Instagram Handle' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} prepend={"@"} />
                  </styled.HalfWidthFieldGroup>
                </styled.FormRow>
              )}

            </div>
          </Accordion>
        )}

        {false && event && (
          <Accordion title="Step 4: Invite Guests" id="step4" closed={this.state.sections.step4} update={this.setSectionState}>
            <div>
              

            </div>
          </Accordion>
        )}
        {false && event && (
          <Accordion title="Step 5: Guest List" id="step5" closed={this.state.sections.step5 || admin} update={this.setSectionState} disabled={admin}>
            <div>
              <styled.TightFormRow>
                <styled.FullWidthFieldGroup>
                  <p style={{marginLeft: '20px'}}>It&#39;s time to compose your invitation and create your guest list for your On the Table event. Guests will receive your invitation with all the details filled in, and can RSVP with a click. Invited guests receive an email right away. Guests on the waitlist do not receive an invitation until you send it.</p>
                </styled.FullWidthFieldGroup>
              </styled.TightFormRow>

              <styled.TightFormRow>
                <styled.FullWidthFieldGroupHighlighted>
                  <h2 style={{marginLeft: '20px'}}><strong>Your two foods and conversation topic</strong></h2>
                  <p style={{marginLeft: '20px'}}>You&#39;re serving {this.props.event.food1}, {this.props.event.food2} and talking about {this.props.event.topic}.</p>
                  <a style={{marginLeft: '20px'}} onClick={(e) => this.setSectionStateAndScroll(e, 'step3')}>Want to change foods and/or topic?</a>
                </styled.FullWidthFieldGroupHighlighted>
              </styled.TightFormRow>
              <styled.FormRow>
                <styled.FullWidthFieldGroupHighlighted>
                  <h2 style={{marginLeft: '20px'}}><strong>Where you&#39;re hosting</strong></h2>
                  <div style={{marginLeft: '20px', marginBottom: '20px'}}>
                    <styled.TightParagraph>{event.address_description}</styled.TightParagraph>
                    <styled.TightParagraph>{event.address_1}</styled.TightParagraph>
                    <styled.TightParagraph>{event.city}, {event.province}, {event.postal_code}</styled.TightParagraph>
                    <styled.TightParagraph>{event.extra_directions}</styled.TightParagraph>
                  </div>
                  <a style={{marginLeft: '20px'}} onClick={(e) => this.setSectionStateAndScroll(e, 'step4')}>Want to change location information?</a>
                </styled.FullWidthFieldGroupHighlighted>
              </styled.FormRow>
              <styled.FormRow>
                <styled.HalfWidthFieldGroup>
                  {invitationDateBlock}
                </styled.HalfWidthFieldGroup>
                <styled.FullWidthFieldGroup>
                  <div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
                    <TextField value={event.invitation_start_time} name='invitation_start_time' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} required={true} label="Start time" />
                    <RadioField name='invitation_start_ampm' update={this.handleEventChange} formProp={event.invitation_start_ampm} values={invitationTime} labels={['am', 'pm']} display={'flex'} />
                  </div>
                </styled.FullWidthFieldGroup>
                <styled.FullWidthFieldGroup>
                  <div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
                    <TextField value={event.invitation_end_time} name='invitation_end_time' update={this.handleEventChange} errorMessage={this.state.warnings} onFocus={this.onFocus} label="End time" />
                    <RadioField name='invitation_end_ampm' update={this.handleEventChange} formProp={event.invitation_end_ampm} values={invitationTime} labels={['am', 'pm']} display={'flex'} />
                  </div>
                </styled.FullWidthFieldGroup>
              </styled.FormRow>
              <styled.FormRow>
                <styled.FullWidthFieldGroup>
                  <TextArea value={event.invitation_message} name='invitation_message' label='Personal Message' update={this.handleEventChange} onFocus={this.onFocus} errorMessage={this.state.warnings} count={true} max={2000} required={true} includeDear={true} />
                </styled.FullWidthFieldGroup>
              </styled.FormRow>
              <styled.FormRow>
                <styled.FullWidthFieldGroup>
                  <p style={{marginLeft: '20px'}}><strong>Upload your logo (optional) (png or jpg)</strong></p>
                  <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '350px', alignItems: 'flex-start'}}>
                    <button className="uploadButton" onClick={(event) => {event.preventDefault()}} ref={this.uploadButton} id='step5-upload' style={{marginBottom: '16px'}}>{ event.invitation_logo ? 'Replace' : 'Choose'} File</button>
                    { event.invitation_logo ? <a style={{margin: '16px'}} onClick={this.handleRemoveImage}>Remove Current Logo</a> : '' }
                    <div className="upload" style={{opacity: '0', height: '10px', background: '#eee', width: '200px', borderRadius: '6px', margin: '0 10px'}}><span className="upload-progress"></span></div>
                    <span className="percent-complete" style={{ marginLeft: '16px'}}></span>
                    { event.invitation_logo ? <img className="invitation-logo" style={{opacity: '1', maxWidth: '150px', maxHeight: '250px', marginLeft: '16px'}} src={event.invitation_logo} /> : '' }
                  </div>
                </styled.FullWidthFieldGroup>
              </styled.FormRow>
              <styled.FormRow>
                <styled.FullWidthFieldGroup>
                    <p style={{marginLeft: '20px'}}><strong>Invitation Preview</strong></p>
                    {this.state.uploadURL && (
                      <EmailPreview event={event} user={user} />
                    )}
                    <EmailPreview event={event} user={user} />
                </styled.FullWidthFieldGroup>
              </styled.FormRow>
            </div>
          </Accordion>
        )}

        {false && event &&
          <Accordion title="Step 6: Send a Reminder" id="step6" closed={this.state.sections.step6 || admin} update={this.setSectionState} >
            <div>
              <GuestListContainer guests={guests} event={event} addGuest={this.props.addGuest} updateGuest={this.props.updateGuest} warnings={this.state.warnings} />
            </div>
          </Accordion>
        }

        {false &&
          <Accordion title="Step 7: Send a Thank you" id="step7" closed={this.state.sections.step7} update={this.setSectionState} step={'step7Closed'} >
          </Accordion>
        }

        {false &&
          <Accordion title="Step 8: Share your Experience" id="step8" closed={this.state.sections.step8} update={this.setSectionState} step={'step8Closed'} >
          </Accordion>
        }

      </div>
    )
  }
}

export default EventForm
